import { isFlagEnabled } from "js/utilities";
import { useTranslation } from "react-i18next";
import {
  isPolicyPayoutAnnuity,
  isInterestSensitiveWholeLifePolicy,
} from "js/utilities";

export const useHelpfulLinks = (policies) => {
  const { t } = useTranslation();
  const allPoliciesAreISWL = policies.every((p) =>
    isInterestSensitiveWholeLifePolicy(p)
  );

  const allPoliciesAreRestrictedPaymentTypes =
    policies.length > 0 &&
    policies.every((p) =>
      ["LZ", "LQ", "LOP"].includes(p?.product?.type?.toUpperCase())
    );
  return isFlagEnabled("ENABLE_SERVICE_TRACKING")
    ? [
        {
          name: t("CustomerDashboard-sectionTwoLink1"),
          route: "/services-claims/forms",
          icon: "ui-icon-clipboard",
        },
        // if all policies are ISWL or LZ/LQ/LOP, hide payment overview link
        !allPoliciesAreISWL &&
          !allPoliciesAreRestrictedPaymentTypes && {
            name: t("CustomerDashboard-sectionTwoLink2"),
            route: "/payment",
            icon: "ui-icon-app",
          },
        // if policy have AnnuityPayoutIndicatorFlag = Y, hide file a claim
        policies.filter((p) => !isPolicyPayoutAnnuity(p)).length > 0 && {
          name: t("CustomerDashboard-sectionTwoLink3"),
          route: "/services-claims/claims/file-a-claim",
          icon: "ui-icon-edit",
        },
        {
          name: t("CustomerDashboard-sectionTwoLink4"),
          route: "/messages",
          icon: "ui-icon-document",
        },
        {
          name: t("CustomerDashboard-sectionTwoLink5"),
          route: "/messages",
          icon: "ui-icon-message",
        },
        {
          name: t("CustomerDashboard-sectionTwoLink7"),
          route: "/services-claims/services",
          icon: "ui-icon-clock",
        },
        {
          name: t("CustomerDashboard-sectionTwoLink8"),
          route: "/services-claims/claims",
          icon: "ui-icon-clock",
        },
      ]
    : [
        {
          name: t("CustomerDashboard-sectionTwoLink1"),
          route: "/services-claims/forms",
          icon: "ui-icon-clipboard",
        },
        // if all policies are ISWL or LZ/LQ/LOP, hide payment overview link
        !allPoliciesAreISWL &&
          !allPoliciesAreRestrictedPaymentTypes && {
            name: t("CustomerDashboard-sectionTwoLink2"),
            route: "/payment",
            icon: "ui-icon-app",
          },
        // if policy have AnnuityPayoutIndicatorFlag = Y, hide file a claim
        policies.filter((p) => !isPolicyPayoutAnnuity(p)).length > 0 && {
          name: t("CustomerDashboard-sectionTwoLink3"),
          route: "/services-claims/claims/file-a-claim",
          icon: "ui-icon-edit",
        },
        {
          name: t("CustomerDashboard-sectionTwoLink4"),
          route: "/messages",
          icon: "ui-icon-document",
        },
        {
          name: t("CustomerDashboard-sectionTwoLink5"),
          route: "/messages",
          icon: "ui-icon-message",
        },
      ];
};
